import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { isObservabilityToolOfType } from 'components/status-checks/authentication-form-validation-utils'
import { StatusCheckMonitorSelection } from 'components/status-checks/form/status-check/StatusCheckMonitorSelection'
import { StatusCheckNameMonitorSuccessEvaluation } from 'components/status-checks/form/status-check/StatusCheckNameMonitorSuccessEvaluation'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

/**
 * Renders the Observability Tool-specific form fields responsible for selecting
 * a monitor to associate with the Health Check, or the generic fields to specify
 * a name, URL, and success evaluation criteria.
 */
export const StatusCheckConnectionFormFields: React.FC = () => {
  const { control } = useFormContext<StatusCheckFormValues>()
  const observabilityTool = useWatch({
    control,
    name: 'observabilityTool'
  })

  const [
    isAwsObservabilityTool,
    isDatadogObservabilityTool,
    isDynatraceObservabilityTool,
    isGrafanaObservabilityTool,
    isPrometheusObservabilityTool
  ] = [
    ObservabilityToolType.AWS,
    ObservabilityToolType.DATADOG,
    ObservabilityToolType.DYNATRACE,
    ObservabilityToolType.GRAFANA,
    ObservabilityToolType.PROMETHEUS
  ].map((type) => isObservabilityToolOfType(type, observabilityTool))

  /*
   * Some Observability tool types support platform-specific mechanisms to select a monitor to
   * associate with the Health Check. We use this flag to denote platform-specific layout rendering.
   */
  const hasToolSpecificFields =
    isAwsObservabilityTool ||
    isDatadogObservabilityTool ||
    isDynatraceObservabilityTool ||
    isGrafanaObservabilityTool ||
    isPrometheusObservabilityTool

  if (hasToolSpecificFields) {
    return (
      <StatusCheckMonitorSelection
        observabilityToolType={observabilityTool.type}
      />
    )
  }

  return <StatusCheckNameMonitorSuccessEvaluation />
}
